<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
         <v-card class="" flat>
              <v-row justify="center" dense>
              <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="PRN" value="prn" color="#0f2027"></v-radio>
                <v-radio label="Application Form No." value="apf_No" color="#0f2027"></v-radio>
            </v-radio-group>
              </v-row>
         </v-card>
        <v-card class="box" v-if="radios == 'prn'">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title> Student Admission Fees</v-toolbar-title>
            </v-toolbar>
            <br />
            <v-row>
                <v-col cols="12" sm="2" md="2"></v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        rounded
                        :items="academic_year_list"
                        v-model="selected_ay"
                        item-text="academicyear"
                        item-value="ay_id"
                        label="Academic Year"
                        dense
                        outlined
                        placeholder="Select Academic Year"
                        :loading="comp_load"
                        @change="celareSelection()"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <v-autocomplete
                        rounded
                        :items="stud_list"
                        v-model="stud_data"
                        item-text="name"
                        label="Search Student"
                        dense
                        return-object
                        outlined
                        :loading="comp_load"
                        @change="getData"
                        placeholder="Search by PRN No or name"
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-card class="box" v-if="basic_student_data != null">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title> Student Details </v-toolbar-title>
                </v-toolbar>
                 <v-toolbar v-if="student_receipts.length > 0" flat dense class="toolbar" align="center" justify="center">
                <v-toolbar-title>Previous Outstanding Fees Receipts</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar><br>
                 <v-data-table :headers="headers1" :items="student_receipts"  class="elevation-1 mytable" dense v-if="student_receipts.length > 0">
                 <template v-slot:item.print="{ item }">
                    <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no,item.ay,item.registration_number)"> <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                        </template>
                        <span>
                            Print Fee Receipt!!!
                        </span>
                    </v-tooltip>
                </template>
                 </v-data-table>
                <v-col cols="12">
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3"><strong>Name : </strong>{{ basic_student_data.registration_number }} : {{ basic_student_data.student_name }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Admission Year : </strong>{{ basic_student_data.learner_addmission_year }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Admission Fee : </strong>{{ admission_fee }}</v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field  @blur="date = parseDate(date)" hint="YYYY/MM/DD format" persistent-hint v-model="date" label=" Select Date" outlined dense rounded prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                </v-col>
                 <v-col cols="12" sm="3" md="3">
                            <v-autocomplete dense rounded required :items="bank_list" v-model="bank" label="Bank" name="bank" item-text="name" item-value="id" outlined ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                        <v-autocomplete dense outlined rounded item-value="id" item-text="name" :items="payment_mode_list" v-model="payment_mode" label="Payment Mode"></v-autocomplete>
                    </v-col>
                    
                     <v-col cols="12" sm="3" md="3">
                        <v-text-field dense outlined rounded v-model="remark" persistent-hint label="Remark"></v-text-field>
                    </v-col>
</v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3"><strong>Standard : </strong>{{ basic_student_data.standard }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Division : </strong>{{ basic_student_data.division }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Roll No. : </strong>{{ basic_student_data.roll_no }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Quota : </strong>{{ basic_student_data.quota }}</v-col>
                    </v-row>
                     <v-row justify="center" dense>
                          <v-btn @click="addAdmissionFee();" v-if="date && payment_mode && bank" class="button">Save</v-btn>
                     </v-row>
                </v-col>
            </v-card>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            comp_load: false,
            loader: false,
            confirm_dialog: false,
            stud_list: null,
            stud_data: null,
            academic_year_list: null,
            selected_ay: null,
            old_ammount: null,
            basic_student_data: null,
            student_fees_structure: [],
            updated_comp_value: [],
            components_value: [],
            components_id: [],
            aws_path: null,
            radios: null,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            menu: false,
            modal: false,
            modal2: false,
            modal3: false,
            menu2: false,
            menu3: false,
            menu11: false,
            date:null,
            bank_list:[],
            bank:null,
            payment_mode_list:[],
            remark:null,
            payment_mode:null,
             headers1: [
                { text: "Sr. No.", value: "srno" },
                { text: "PRN No.", value: "registration_number"},
                { text: "Name", value: "name"},
                { text: "Academic Year", value: "fee_ay" },
                { text: "Standard", value: "standard" },
                { text: "Quota", value: "quota" },
               // { text: "Stream", value: "stream" },
                { text: "Receipt No", value: "receipt_no" },
                { text: "Receipt Date", value: "receipt_date" },
                { text: "Amount", value: "amount" },
                { text: "Payment Mode", value: "payment_mode" },
                { text: "Remark", value: "remark" },
                { text: "Print Receipt", value: "print", sortable: true },
            ],
            student_receipts:[]
        }),
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents_for_account")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.academic_year_list = res.data.academic_year_list;
                        this.selected_ay = res.data.current_ay;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
              print(receipt_no,ay,registration_number){
                this.receipt_no = receipt_no;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                let routeData = this.$router.resolve({name: 'student-admission-receipt'});
                window.open(routeData.href, '_blank');
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            clearAmount() {
                this.getData();
                this.confirm_dialog = false;
            },
            addAdmissionFee(){
                 const formData = {
                    learner_id: this.stud_data.lid,
                    ay_id: this.selected_ay,
                    date : this.date,
                    remark : this.remark,
                    bank : this.bank,
                    mode : this.payment_mode
                };
                 axios
                    .post("/AccountingAndFees/saveAdmissionFeeAmount", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                             this.showSnackbar("#4caf50", "Admission Fee Paid Successfully..."); 
                        }
                        if (res.data.flag == "NO") {
                             this.showSnackbar("#b71c1c",res.data.fmsg);  
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        // alert("Somthing went wrong!!!");
                    })
                    .finally(() => {});
            },
            getData() {
                this.basic_student_data = null;
                this.student_fees_structure = [];
                const formData = {
                    learner_id: this.stud_data.lid,
                    ay_id: this.selected_ay,
                };
                axios
                    .post("/AccountingAndFees/getStudentwiseFeesStructure", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                if (res.data.status == "Yes") {
                                    this.basic_student_data = res.data.basic_student_data;
                                    this.admission_fee = res.data.admission_fee
                                    this.bank_list = res.data.bank_list
                                    this.payment_mode_list = res.data.mode_list
                                    this.aws_path = res.data.aws_path;
                                    this.student_receipts = res.data.student_receipts
                                } 
                                // else {
                                //     this.showSnackbar("#b71c1c", res.data.status_reasone);
                                // }
                            } 
                            // else if (res.data.flag == "NO") {
                            //     this.showSnackbar("#b71c1c", res.data.snackbar);
                            // }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        // alert("Somthing went wrong!!!");
                    })
                    .finally(() => {});
            },
            celareSelection() {
                this.student_fees_structure = [];
                this.basic_student_data = null;
                this.stud_data = null;
            },
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }
    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
</style>
